/* Warranty badge (snippets/warranty-badge.liquid). The badge is a native <details>, so
   it opens and closes without this file. This adds closing on an outside click and on
   Escape, and, in the warranty row, room under the row for the open card. Listeners
   are delegated from document, so badges rendered later (quick view) are covered and
   no element constructor reads markup. */
(() => {
  if (window.warrantyBadgeBound) return;
  window.warrantyBadgeBound = true;

  const OPEN = 'details[data-warranty-badge][open]';

  document.addEventListener('click', (event) => {
    document.querySelectorAll(OPEN).forEach((badge) => {
      if (!badge.contains(event.target)) badge.open = false;
    });
  });

  // Drawer in the warranty row (product-information-blocks.liquid): while a badge there
  // is open, reserve its card's height under the row so the page moves down instead of
  // being covered. The CSS reads --warranty-panel-space (warranty-badge.css).
  const ROW = '.product__warranty-row';
  const reserve = (badge) => {
    const row = badge.closest(ROW);
    if (!row) return;
    const card = badge.querySelector('.warranty-badge__card');
    if (!badge.open || !card) {
      row.style.removeProperty('--warranty-panel-space');
      return;
    }
    const gap = card.offsetTop - row.offsetHeight; // the card's top offset below the row
    row.style.setProperty('--warranty-panel-space', `${card.offsetHeight + Math.max(gap, 0)}px`);
  };
  const resized = 'ResizeObserver' in window
    ? new ResizeObserver((entries) => entries.forEach((entry) => reserve(entry.target.closest('details'))))
    : null;

  // toggle does not bubble; capture it on its way down.
  document.addEventListener('toggle', (event) => {
    const badge = event.target;
    if (!(badge instanceof HTMLDetailsElement) || !badge.matches('[data-warranty-badge]') || !badge.closest(ROW)) return;
    reserve(badge);
    const card = badge.querySelector('.warranty-badge__card');
    if (resized && card) badge.open ? resized.observe(card) : resized.unobserve(card);
  }, true);

  // A badge already open when this runs (its toggle came first) still gets its room.
  document.querySelectorAll(`${ROW} details[data-warranty-badge][open]`).forEach((badge) => {
    reserve(badge);
    const card = badge.querySelector('.warranty-badge__card');
    if (resized && card) resized.observe(card);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const badge = event.target instanceof Element ? event.target.closest(OPEN) : null;
    if (!badge) return;
    badge.open = false;
    badge.querySelector('summary').focus();
  });
})();
